/**
 * Created by jv on 07/04/2017.
 */
const utils = require("Sources/utils/utils");
const LanguageManager = require("Sources/services/languagemanager");

require("Styles/components/user-type-selection.scss");

module.exports = class UserTypeSelectionTemplate
{
  constructor(options)
  {
    if(utils.isNull(options))
    {
      throw "options must be defined";
    }

    this.appendTo = $(options.appendTo);

    this.userTypes = utils.isArray(options.userTypes) ? options.userTypes : [];

    this.selectedCountry = null;
    this.selectedUserType = null;

    this.onCountrySelected = options.onCountrySelected;
    this.onUserTypeSelected = options.onUserTypeSelected;
    this.onRender = options.onRender;
    this.afterRender = options.afterRender;

    this.userSelectionWrapper = null;
    this.countryWrapper = null;
    this.userTypeWrapper = null;

    this.create();

    utils.devLog(this.userTypes);
  }

  create()
  {
    if(this._initialized !== true)
    {
      this.userSelectionWrapper = $("<div class='user-selection-wrapper clearfix'></div>");
      this.countryWrapper = $("<div class='country-wrapper'></div>").appendTo(this.userSelectionWrapper);
      this.userTypeWrapper = $("<div class='user-type-wrapper'></div>").appendTo(this.userSelectionWrapper);

      this.appendTo.append(this.userSelectionWrapper);

      this.rerender();

      this._initialized = true;
    }
  }

  destroy()
  {
    if(utils.isNotNull(this.userSelectionWrapper) && this.userSelectionWrapper.length)
    {
      this.userSelectionWrapper.remove();
    }

    this._initialized = false;
  }

  show()
  {
    if(utils.isNotNull(this.userSelectionWrapper) && this.userSelectionWrapper.length)
    {
      this.userSelectionWrapper.show();
    }
  }

  hide()
  {
    if(utils.isNotNull(this.userSelectionWrapper) && this.userSelectionWrapper.length)
    {
      this.userSelectionWrapper.hide();
    }
  }

  rerender()
  {
    this.renderUserTypeWrapper();
  }

  renderUserTypeWrapper()
  {
    this.renderCountrySelection();
    this.renderUserTypeSelection();
  }

  renderCountrySelection()
  {
    var that = this;

    this.countryWrapper.empty();
    this.countryWrapper.append("<h4 class='subtitle center-text'>" + LanguageManager.getValueForKey("store.user_type_selection.countries.title"));

    var countrySelectionEl = $("<div class='countries clearfix'></div>");

    for(var i = 0; i < this.userTypes.length; i++)
    {
      var countryOption = this.userTypes[i];
      countrySelectionEl.append("<div class='country-option' data-locale='" + countryOption.locale + "'><div class='logo'><span class='flag flag-" + countryOption.locale + "'></span></div><div class='country-text'>" + countryOption.displayText + "</div></div>");
    }

    countrySelectionEl.find(".country-option").on("click", function(e)
    {
      countrySelectionEl.find(".country-option").removeClass("selected");

      var $this = $(this);
      $this.addClass("selected");
      var localeSelected = $this.attr("data-locale");

      that.selectedUserType = null;

      for(var i = 0; i < that.userTypes.length; i++)
      {
        if(that.userTypes[i].locale === localeSelected)
        {
          that.selectedCountry = that.userTypes[i];
          break;
        }
      }

      that.renderUserTypeSelection();

      if(utils.isFunction(that.onCountrySelected))
      {
        that.onCountrySelected(that.selectedCountry);
      }
    });

    this.countryWrapper.append(countrySelectionEl);
  }

  renderUserTypeSelection()
  {
    if(utils.isNotNull(this.selectedCountry))
    {
      var that = this;

      this.userTypeWrapper.empty();

      this.userTypeWrapper.append("<h4 class='subtitle center-text'>" + LanguageManager.getValueForKey("store.user_type_selection.user_types.title"));

      var userTypesEl = $("<div class='user-types clearfix'></div>");

      for(var i = 0; i < this.selectedCountry.userTypes.length; i++)
      {
        var userType = this.selectedCountry.userTypes[i];
        userTypesEl.append("<div class='user-type' data-user-type='" + userType.key + "'><div class='logo'><span class='user-type-logo user-type-" + userType.key.toLowerCase() + "'</span></div><div class='user-type-text'>" + userType.displayText + "</div></div>");
      }

      userTypesEl.find(".user-type").on("click", function(e)
      {
        userTypesEl.find(".user-type").removeClass("selected");

        var $this = $(this);
        $this.addClass("selected");
        var userTypeSelected = $this.attr("data-user-type");

        for(var i = 0; i < that.selectedCountry.userTypes.length; i++)
        {
          var userType = that.selectedCountry.userTypes[i];
          if(userType.key === userTypeSelected)
          {
            that.selectedUserType = userType;
            break;
          }
        }

        if(utils.isFunction(that.onUserTypeSelected))
        {
          that.onUserTypeSelected(that.selectedUserType);
        }
      });

      this.userTypeWrapper.append(userTypesEl);
    }
  }
};



// WEBPACK FOOTER //
// ./app/js/templates/user-type-selection.template.js